import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {FormControl, InputLabel, FilledInput} from '@material-ui/core';

const CssFormControl = withStyles({
	root: {
		background: 'rgba(60, 60, 60)',
		'& label': {
			color: 'white'
		},
		'& label.Mui-focused': {
			color: 'white'
		},
		'& .MuiSvgIcon-root': {
			color: 'white'
		},
		'& .MuiFormLabel-root.Mui-error': {
			color: 'lightgrey'
		},
		'& .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)': {
			marginTop: '22px'
		},
		'& .MuiFilledInput-input': {
			padding: '35px 12px 12px',
			fontSize: '13px',
			color: 'white',
			fontWeight: 'bold'
		},
		'& .MuiFilledInput-underline:before': {
			borderBottom: '3px solid rgba(40, 40, 40)',
			borderBottomColor: 'rgba(40, 40, 40)'
		},
		'& .MuiFilledInput-underline:after': {
			borderBottom: '3px solid rgba(40, 40, 40)',
			borderBottomColor: 'white'
		},
		'& .MuiFilledInput-underline.Mui-error:after': {
			borderBottom: '3px solid rgb(247, 12, 71)',
			borderBottomColor: 'rgb(247, 12, 71)'
		},
		'& .MuiFormLabel-asterisk.Mui-error': {
			color: 'white'
		}
	}
})(FormControl);

export default (props) => {
	const {endAdornment, variant, required, value, onChange, error, helperText, onKeyDown, placeholder, className, fullWidth} = props;
	return <CssFormControl variant={variant} required={required} className={className} fullWidth={fullWidth} helpertext={helperText} error={error}>
		<InputLabel>{placeholder}</InputLabel>
		<FilledInput
			label={placeholder}
			value={value}
			onKeyDown={onKeyDown}
			autoComplete='off'
			onChange={onChange}
			endAdornment={endAdornment}
		/>
	</CssFormControl>;
};
